<template>
    <div>
        <b-tooltip v-if="popoverText" :target="badgeId" triggers="hover">
            <div v-html="popoverText"></div>
        </b-tooltip>
        <div :id="badgeId" class="flag-badge" :style="style" @click="$emit('click')">{{ value ? textOn : textOff }}
        </div>
    </div>
</template>

<script>
import { isDarkColor } from '@/utils/helpers'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        textOn: {
            type: String,
            default: ''
        },
        textOff: {
            type: String,
            default: ''
        },
        colorOn: {
            type: String,
            default: ''
        },
        colorOff: {
            type: String,
            default: ''
        },
        popoverText: {
            type: String,
            default: ''
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        style() {
            return {
                backgroundColor: this.value ? this.colorOn : this.colorOff,
                color: this.value ? isDarkColor(this.colorOn) ? '#212529' : '#FFFFFF' : isDarkColor(this.colorOff) ? '#212529' : '#FFFFFF',
                cursor: this.clickable ? 'pointer' : 'default'
            }
        },
        badgeId() {
            return `badge-${this._uid}`
        }
    }
}
</script>

<style scoped>
.flag-badge {
    padding: 0.25rem 0.5rem;
    border-radius: 10px;
    font-weight: bold;
    font-size: 0.875rem;
    text-wrap: nowrap;
    text-align: center;
}
</style>
